import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

export const provideDialogDefaultOptions = () => {
    return {
        provide: MAT_DIALOG_DEFAULT_OPTIONS,
        useValue: { panelClass: 'm-4', autoFocus: false },
    };
};
